import React from "react";

function Error() {
  return (
    <div>
      <h1>404 page not found</h1>
    </div>
  );
}

export default Error;
